import { ShieldCheck } from "lucide-react";
import Reveal from "@/components/Reveal";

const conditionalProducts = [
  "Crude Glycerin",
  "Corn Steep Liquor (CSL)",
  "Vinasse / CMS",
  "Selected Non-Food Fermentation By-Products",
  "Selected Industrial Glycerin",
  "PFAD / Fatty Matter",
  "Selected Liquid Fertilizer",
];

const Products = () => (
  <section id="products" data-testid="products-section" className="scroll-mt-20 bg-ujn-offwhite text-ujn-charcoal">
    <div className="mx-auto max-w-7xl px-5 py-20 sm:py-28 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="font-mono text-[11px] tracking-[0.28em] text-ujn-medium">PRODUCT FOCUS</p>
        <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-ujn-deep sm:text-3xl lg:text-4xl">
          MOLASSES FIRST.
          <br />
          OTHER LIQUIDS ARE CONDITIONAL.
        </h2>
      </Reveal>

      <Reveal delay={0.1} className="mt-14 grid gap-10 lg:grid-cols-5 lg:gap-14">
        <div data-testid="product-molasses" className="flex flex-col justify-between border border-ujn-deep bg-ujn-deep p-8 sm:p-10 lg:col-span-2">
          <div>
            <p className="font-mono text-[10px] tracking-[0.24em] text-ujn-subtle">PRIMARY PRODUCT</p>
            <p className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-ujn-offwhite sm:text-5xl">
              MOLASSES
            </p>
          </div>
          <p className="mt-10 max-w-sm text-sm leading-relaxed text-ujn-offwhite/70">
            The core storage focus of the UJN facility, supported by dedicated bulk liquid storage
            and handling infrastructure.
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.24em] text-ujn-medium">OTHER POTENTIAL PRODUCT CATEGORIES</p>
          <div className="mt-5 grid grid-cols-1 gap-px border border-ujn-medium/15 bg-ujn-medium/15 sm:grid-cols-2">
            {conditionalProducts.map((p, i) => (
              <div key={p} data-testid={`product-conditional-${i + 1}`} className="bg-ujn-offwhite px-5 py-4">
                <span className="font-mono text-[11px] tracking-[0.1em] text-ujn-deep">{p.toUpperCase()}</span>
              </div>
            ))}
          </div>

          <div
            data-testid="product-hse-note"
            className="mt-8 flex items-start gap-4 border border-ujn-medium/30 bg-ujn-sand px-6 py-5"
          >
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-ujn-medium" />
            <p className="text-sm leading-relaxed text-ujn-charcoal/85">
              Product storage is subject to technical compatibility, handling requirements and HSE assessment.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Products;
